<h2 mat-dialog-title>Collega COT – {{ user.username }}</h2>
<mat-dialog-content>
  @if (loading) {
    <div class="d-flex justify-content-center p-3">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else if (errorMessage && !saving) {
    <p class="text-danger mb-2">{{ errorMessage }}</p>
  } @else {
    <p class="mb-3">Seleziona le COT da associare all'utente.</p>
    <div class="cot-list">
      @for (cot of allCots; track cot.id) {
        <div class="cot-row">
          <mat-checkbox [checked]="isSelected(cot)" (change)="toggle(cot)">
            {{ cot.codice }} – {{ cot.descrizione || '—' }}
          </mat-checkbox>
        </div>
      }
      @if (allCots.length === 0) {
        <p class="text-muted">Nessuna COT disponibile.</p>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
  @if (!loading) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
      {{ saving ? 'Salvataggio...' : 'Salva' }}
    </button>
  }
</mat-dialog-actions>
